import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';
import { PlansAndPurchaseTabGzDataProvider } from '../dataProvider/PlansAndPurchaseTabGzDataProvider';

export class PlansAndPurchaseTabDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PlansAndPurchaseTabGzDataProvider);
  }
}
